import { render, staticRenderFns } from "./document-modal.vue?vue&type=template&id=52122ed2&scoped=true&"
import script from "./document-modal.vue?vue&type=script&lang=js&"
export * from "./document-modal.vue?vue&type=script&lang=js&"
import style0 from "./document-modal.vue?vue&type=style&index=0&id=52122ed2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52122ed2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow})
